/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-11-30 09:23:53
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-03-15 17:43:39
 */
import request from '../../utils/request'
import server from './config'

const loginUrl = `${server.MS_PATIENT_CONSUMMER}/patient/1/login`
const getDetailUrl = `${server.MS_PATIENT_CONSUMMER}/patient/1/getPatientDetailInfo`
export default {
    loginUrl,
    getDetailUrl,
    /**
     * code获取详情
     * 获取到详情后需要判断是否需要登录或者绑定
     * 并记录当前url
     */
    getInfoByCode:(data)=>{
       return request({
            url:loginUrl,
            method: 'post',
            data,
        })
    },
    /**
     * 绑定手机号
     */

    bindPhone:(data)=>{
        return request({
             url: `${server.MS_PATIENT_CONSUMMER}/patient/1/bind_phone`,
             method: 'post',
             data,
         })
     },
    /**
     * 获取手机号登录验证码
     */
    loginCode:(data)=>{
        return request({
             url: `${server.MS_PATIENT_CONSUMMER}/patient/1/sms_code/login/send`,
             method: 'post',
             data: {
                 ...data,
                 appid: sessionStorage.getItem('appid')
             },
         })
     },
    /**
     * 获取绑定手机号验证码
     */
    bindPhoneCode:(data)=>{
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/1/sms_code/bind_phone/send`,
            method: 'post',
            // data,
            data: {
                ...data,
                appid: sessionStorage.getItem('appid')
            },
        })
    },

    /**
     * 退出登录
     */
    userLogout:(data)=>{
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/1/logout`,
            method: 'post',
            data,
        })
    },

    /**
     * 获取用户详情
     */
    getDetail:(data,noToast=false)=>{
        return request({
            url:getDetailUrl,
            method: 'post',
            data,
            noToast
          })
    },
    /**
     * 获取就诊人列表和医生的关系列表
     */
    getPatientListByDoctor:(data)=>{
        return request({
             url: `${server.MS_PATIENT_CONSUMMER}/patient/consult/1/getListByDoctorIdAndPatientId`,
             method: 'post',
             data,
         })
     },
     /**
      * 保存就诊人（创建咨询时候使用）
      */
     addMemberForConsultRecord:(data)=>{
        return request({
             url: `${server.MS_PATIENT_CONSUMMER}/patient/consult/1/addMemberForConsultRecord`,
             method: 'post',
             data,
         })
     },
     /**
      * 选择就诊人创建咨询
      */
     updateRecordMemberInfo:(data)=>{
        return request({
             url: `${server.MS_PATIENT_CONSUMMER}/patient/consult/1/updateRecordMemberInfo`,
             method: 'post',
             data,
         })
     },
     /**
      * 就诊人详情
      */
     getDetailById:(data)=>{
        return request({
             url: `${server.MS_PATIENT_CONSUMMER}/patient/member/1/getDetailById`,
             method: 'post',
             data,
         })
     },
     /**
      * 就诊人列表（所有的）
      */
     getPatientList:(data)=>{
        return request({
             url: `${server.MS_PATIENT_CONSUMMER}/patient/member/1/getPageList`,
             method: 'post',
             data,
         })
     },
     /**
      * 删除就诊人
      */
     deletePatient:(data)=>{
        return request({
             url: `${server.MS_PATIENT_CONSUMMER}/patient/member/1/statusOff`,
             method: 'post',
             data,
         })
     },
     /**
      * 添加就诊人
      */
     addMemberForPatient:(data)=>{
        return request({
             url: `${server.MS_PATIENT_CONSUMMER}/patient/member/1/addMemberForPatient`,
             method: 'post',
             data,
         })
     },
     /**
      * 编辑就诊人
      */
     editPatientMemberInfo:(data)=>{
        return request({
             url: `${server.MS_PATIENT_CONSUMMER}/patient/member/1/editPatientMemberInfo`,
             method: 'post',
             data,
        })
     },
     /**
      * 获取患者的imToken
      */
     getPatientImToken:(data)=>{
        return request({
             url: `${server.MS_PATIENT_CONSUMMER}/patient/member/1/getPatientImToken`,
             method: 'post',
             data,
         })
     },
     /**
      * 获取就诊人列表（和医生相关）
      */
     doctorShowPatientMember:(data)=>{
        return request({
             url: `${server.MS_PATIENT_CONSUMMER}/patient/1/doctorShowPatientMember`,
             method: 'post',
             data,
         })
     },
     /**
      * 添加就诊人报道时候用的
      */
     patientMemberCreate:(data)=>{
        return request({
             url: `${server.MS_PATIENT_CONSUMMER}/patient/1/patientMemberCreate`,
             method: 'post',
             data,
         })
     },
     /**
      * 向医生报道
      */
     patientMemberReportDoctor:(data)=>{
        return request({
             url: `${server.MS_PATIENT_CONSUMMER}/patient/1/patientMemberReportDoctor`,
             method: 'post',
             data,
         })
     },
     /**
      * 获取病例列表
      */
     getPatientMemberCaseList(data){
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patientCase/1/getPatientMemberCaseList`,
            method: 'post',
            data,
        })
     },
     /**
      * 健康档案
      */
     getHealthRecords(data){
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/member/1/getHealthRecords`,
            method: 'post',
            data,
        })
     },
    /**
     * 修改手机号
     */
    updatePhone(data){
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/member/1/updatePhoneSendVerificationCode`,
            method: 'post',
            data,
        })
    },
    /**
     * 患者是否发起过咨询
     */
    isHaveConsult(params){
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/1/isHaveConsult`,
            method: 'get',
            params,
        })
    },
    /**
     * 获取患者的疾病表单记录
     */
    getPatientFormList(params){
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/member/1/getDiseaseFormRecord`,
            method: 'get',
            params,
        })
    },
    /**
     * 保存患者的疾病表单记录
     */
    savePatientFormRecord(data){
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/member/1/saveOrUpdateDiseaseForm`,
            method: 'post',
            data,
        })
    },
    /**
     * 获取患者的疾病表单记录详情
     */
    getPatientFormDetail(params){
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/member/1/getDiseaseFormDetail/${params.id}`,
            method: 'get',
            params,
        })
    },
}



// WEBPACK FOOTER //
// ./src/api/modules/user.js